import { render } from "./WhyToChooseSection.vue?vue&type=template&id=d1ac75a0"
import script from "./WhyToChooseSection.vue?vue&type=script&lang=js"
export * from "./WhyToChooseSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__